import React, { createContext, useContext, useState, useEffect } from 'react';
import i18n from '../../i18n';

const ly = (key, opts) => i18n.t(`serviceMessages.layout.${key}`, opts);

const LayoutContext = createContext();

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error(ly('hook_outside_provider'));
  }
  return context;
};

export const LayoutProvider = ({ children }) => {
  // Get initial layout preference from localStorage, default to 'sidebar'
  const [layoutMode, setLayoutMode] = useState(() => {
    const saved = localStorage.getItem('qawaem_layout_mode');
    return saved || 'sidebar'; // 'sidebar' or 'topbar'
  });

  // Save to localStorage whenever layout mode changes
  useEffect(() => {
    localStorage.setItem('qawaem_layout_mode', layoutMode);
  }, [layoutMode]);

  const toggleLayout = () => {
    setLayoutMode(prev => prev === 'sidebar' ? 'topbar' : 'sidebar');
  };

  const setSidebarMode = () => setLayoutMode('sidebar');
  const setTopBarMode = () => setLayoutMode('topbar');

  const value = {
    layoutMode,
    isSidebarMode: layoutMode === 'sidebar',
    isTopBarMode: layoutMode === 'topbar',
    toggleLayout,
    setSidebarMode,
    setTopBarMode
  };

  return (
    <LayoutContext.Provider value={value}>
      {children}
    </LayoutContext.Provider>
  );
};

export default LayoutContext;

